import { jsxs, jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { Rating } from "@nxt-costco-com/forge-components";
import { SpaceXxs } from "@nxt-costco-com/forge-design-tokens";
import { ProductInfo } from "./components/ProductInfo/index.js";
const ProductDetailsBlock = ({
  productTileMaxLineNumber,
  partNumber,
  reviewRatingData,
  showReviews,
  hideReviewStarValue = false,
  ratingVariant,
  emptyReviewText = ""
}) => {
  if (reviewRatingData && reviewRatingData.ariaLabel === "No reviews.") {
    reviewRatingData.ariaLabel = "(0)";
  }
  const staticUniqueId = true;
  return /* @__PURE__ */ jsxs(
    Box,
    {
      sx: {
        display: "flex",
        flexDirection: "column",
        gap: SpaceXxs,
        width: "100%"
      },
      children: [
        /* @__PURE__ */ jsx(ProductInfo, { productTileMaxLineNumber }),
        showReviews && reviewRatingData && /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(
          Rating,
          {
            size: "small",
            uniqueId: `ProductRating_${partNumber}`,
            ...reviewRatingData,
            displayAvgRatingAsText: hideReviewStarValue ? false : Boolean(
              reviewRatingData == null ? void 0 : reviewRatingData.displayAvgRatingAsText
            ),
            displayVariant: ratingVariant,
            staticUniqueId,
            emptyReviewText: emptyReviewText || ""
          }
        ) })
      ]
    }
  );
};
export {
  ProductDetailsBlock
};
